import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  EmailMessageByToken,
  EmailMessageResponse,
} from "../../models/Communication.model";

const API_URL = environment.apiUrl;

export const sendEmailMessage = createAsyncThunk<
  EmailMessageResponse,
  EmailMessageByToken,
  { rejectValue: string }
>("email/sendEmailMessage", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Email/SendEmailMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}`);
    }

    const data: EmailMessageResponse = await response.json();
    if (!data.success) {
      return rejectWithValue(data.message || "Failed to send email");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
